import SettingsModule, {SettingsMenuTopCategory} from "../../../../core/modules/settings-module";

export default class ProjectAccessSettingsModule extends SettingsModule {

    constructor() {
        super({
            name                     : "Project Access",
            description              : "Project Access defines user permissions and access to a specific folder or project, including tasks, adding new project users, creating subprojects, editing project settings, and more. It operates independently of the user's role within the organization. For instance, a user holding the organization role of Manager may have limited access to a particular folder or project.",
            svgIcon                  : "isvg-project-access",
            typeLabel                : "Access & Permissions",
            settingsUrl              : "settings/project-access",
            settingsMenuTopCategory  : SettingsMenuTopCategory.ORGANIZATION
        });
    }

}
